var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-pane',{key:_vm.key,attrs:{"title":_vm.title}},[_c('b-icon',{attrs:{"slot":"title","icon":_vm.icon,"scale":"1.1"},slot:"title"}),_vm._v(" "+_vm._s(_vm.index)+" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }